import { Locale } from "../schema/Locale.js";

export function sameValueForEveryLocale<T>(value: T): Record<Locale, T> {
	return Object.fromEntries(Object.values(Locale).map((locale) => [locale, value])) as Record<Locale, T>;
}
